import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * GSAP on scroll animations
 *
 * - Fade animations
 */
export default function scrollAnimations() {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

   /**
     * Fade animations
     * needs .animation-container
     * needs data-animation="" attribute
     * optional data-speed="0.5" for animation speed (1 is 1 second)
     * optional data-staggered="true" for an incremental entering of elements (not on mobile)
     * optional data-delay="0.5" // to add a start delay (1 is 1 second)
     */
    const animationContainers = document.querySelectorAll(
        '.animation-container'
    );
    if (animationContainers) {
        const isMobile = window.innerWidth < 768 ? true : false;

        for (let container of animationContainers) {
            const animationElements =
                container.querySelectorAll('[data-animation]');

            // ScrollTrigger
            ScrollTrigger.batch(animationElements, {
                onEnter: batch => {
                    batch.forEach((element, index) => {
                        const speed = element.dataset.speed
                            ? element.dataset.speed
                            : 0.5;
                        const isStaggered = element.dataset.staggered;
                        const delay = element.dataset.delay
                            ? element.dataset.delay
                            : 0;

                        // Animation options
                        let animationOptions = {
                            duration: speed,
                            delay:
                                isStaggered && !isMobile
                                    ? index * 0.3 + delay
                                    : delay,
                            opacity: 1,
                        };

                        // Animation type
                        switch (element.dataset.animation) {
                            case 'fade-in':
                            case 'fade-in-centered':
                                animationOptions.scale = 1;
                                break;
                            case 'fade-left':
                            case 'fade-right':
                            case 'fade-left-full':
                            case 'fade-right-full':
                                animationOptions.x = 0;
                                break;
                            case 'fade-up':
                                animationOptions.y = 0;
                                break;
                            default:
                                console.error(
                                    'Wrong or missing data-animation type'
                                );
                        }

                        gsap.to(element, {
                            ...animationOptions,
                        });
                    });
                },
                once: true,
            });
        }
    }
}
